import React from 'react';


export let TableContext = React.createContext({
    config: {
        showID: true, 
        showAuthor: true, 
        showTimestamp: true, 
        custom: true || undefined,
        addText: "" || undefined,
        deleteText: "" || undefined,
        toolbox: true || undefined,
        filter: true || undefined,
        basic: true || undefined,
        disableAuthor: true || undefined,
        disableID: true || undefined,
        disableImport: true || undefined,
        disableAdd: true || undefined,
        disableExport: true || undefined,
    }, 
    schema: [] || null,
    metadata: {
        collection: "", 
        document: "" || undefined
    },
    records: []
})